import DestroyIFrame from 'wrapper/lib/frames/utils/DestroyIFrame'
import GenerateIFrame from 'wrapper/lib/frames/GenerateIFrame'

const FrameError = (message) => {
    if (message.includes('FRAME/ERROR')) {
        DestroyIFrame('pico_launcher')
        DestroyIFrame('pico_menu')
        DestroyIFrame('pico_prompt')
        DestroyIFrame('pico_header')

        GenerateIFrame('FRAME/CREATE_CHILD/error')
    }
}

export default FrameError
